/**
 * @packageDocumentation
 * @module Checks
 */
/**
 * Detects if the value is primitive, i.e. is null or not equal to an object
 *
 * @param {unknown} value
 *
 * @return {boolean}
 */
export var isPrimitive = function (value) { return (value === null
    || !(value instanceof Object)); };
//# sourceMappingURL=isPrimitive.js.map